/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InfusionsViewerAliases {
  ADJUST_INFUSION_SPEED_BUTTON_PANEL = 'adjust-infusion-speed-button-panel',
  ADJUST_INFUSION_SPEED_BUTTON_PANEL_PADDING = 'adjust-infusion-speed-button-panel-padding',
  ADMINISTRATION_BY_PROCESS_ACTION = 'administration-by-process-action',
  ADMINISTRATION_BY_SCHEDULE_ACTION = 'administration-by-schedule-action',
  CONTEXTUAL_BAR = 'contextual-bar',
  CONTEXTUAL_BAR_ACTION_ADJUST_SPEED = 'contextual-bar-action-adjust-speed',
  CONTEXTUAL_BAR_ACTION_SCHEDULE = 'contextual-bar-action-schedule',
  CONTEXTUAL_BAR_ACTION_SUSPEND = 'contextual-bar-action-suspend',
  CONTEXTUAL_BAR_ACTION_TERMINATE = 'contextual-bar-action-terminate',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INFUSION_REVERSE_LAST_EVENT_ACTION = 'infusion-reverse-last-event-action',
  INFUSION_STOP_BUTTON = 'infusion-stop-button',
  INFUSIONS_VIEWER_BUTTON_PANEL_CONTAINER = 'infusions-viewer-button-panel-container',
  INFUSIONS_VIEWER_DECK = 'infusions-viewer-deck',
  LAYOUT_INFUSIONS_VIEWER = 'layout-infusions-viewer',
  MEDICATION_OR_SOLUTION_DETAILS_CARD = 'medication-or-solution-details-card',
  PANEL_HEADER = 'panel-header',
  PANEL_INFUSIONS_VIEWER_CONTENT = 'panel-infusions-viewer-content',
}
export { InfusionsViewerAliases };
